<template>
  <div v-if="isLoggedIn" style="min-height: 100vh;">
    <v-navigation-drawer v-model="drawer" class="nav-draver" width="270" app clipped>
      <v-list v-ripple="false" dense flat>
        <v-list-item-group v-model="selectedTab" v-ripple="false" active-class="navmenu-item-active">
          <v-list-item
            v-for="menu in hasMatchedMenuRoles" :id="menu.id" :key="menu.title" v-ripple="false"
            class="my-2 " color="primary" :to="menu.link" :href="menu.href"
          >
            <v-list-item-icon v-ripple="false">
              <v-icon v-ripple="false" color="primary">
                {{ menu.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content v-ripple="false">
              <v-list-item-title v-ripple="false" class="subtitle-2 font-weight-bold">
                {{ menu.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app class="header-main" dark clipped-left>
      <!-- ez itt eleg shitty de legalabb jo -->
      <v-sheet height="30" width="30" class="header-button rounded-lg">
        <v-app-bar-nav-icon height="30" width="30" @click.stop="drawer = !drawer">
          <!-- TODO: animacio -->
          <v-icon>{{ drawer ? 'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon>
        </v-app-bar-nav-icon>
      </v-sheet>

      <v-img class="mx-2" :src="headerLogoUrl" max-height="35" max-width="97" contain></v-img>

      <v-spacer></v-spacer>

      <v-select
        v-if="showDevFeatures" v-model="selectedTheme" label="Select Theme" style="width: 64px"
        class="headerTextColor--text" :items="myThemes" @change="setTheme()"
      ></v-select>
      <!--  -->
      <v-menu offset-y>
        <template #activator="{ on, attrs }">
          <v-btn id="profile_button" v-bind="attrs" class="mr-4 header-button headerTextColor--text" v-on="on">
            <v-icon left>mdi-account-outline</v-icon>
            <span>{{ currentUser.email }} </span>
          </v-btn>
        </template>
        <v-list id="profile_menu">
          <v-list-item id="profile_nav_button" link color="primary" :to="isRDSSMenusActive ? '/user/profilerdss' : '/user/profile'">
            <v-icon class="mr-2" color="primary">mdi-cog-outline</v-icon>
            {{ $t('users.title.profile') }}
          </v-list-item>
          <v-list-item v-if="sealEnabled" id="credential_nav_button" link color="primary" to="/credentials">
            <v-icon class="mr-2" color="primary">mdi-certificate-outline</v-icon>

            {{ $t('navigationMenu.credentials') }}
          </v-list-item>
          <v-list-item id="logout_nav_button" link to="/logout">
            <v-icon class="mr-2" color="error">
              mdi-logout
            </v-icon>

            {{ $t("main.logout") }}
          </v-list-item>
        </v-list>
      </v-menu>
      <!--  -->
    </v-app-bar>

    <v-main>
      <v-container fill-height fluid>
        <v-snackbar
          v-show="mobileWarning" :timeout="-1" :value="true" multi-line centered min-width="90%"
          color="red accent-2" class="mobilewarning"
        >
          {{ $t('toastMessage.mobileWarning') }}
          <template #action="{ attrs }">
            <v-btn icon v-bind="attrs" @click="closeMobileWarning">
              <v-icon large>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <!-- <keep-alive> -->
        <router-view :key="$route.path">
        </router-view>
        <!-- </keep-alive> -->
        <v-spacer></v-spacer>
      </v-container>
    </v-main>

    <div
      class="versionBottom" :class="{ 'hidden': versionHovered }" @mouseover="versionHovered = true"
      @mouseleave="versionHoveredHandle"
    >
      <div>{{ rsspVersion }}</div>
      <div v-if="rdssVersion">{{ rdssVersion }}</div>
    </div>
    <vue-cookie-accept-decline
      v-if="HOTJAR_SITEID && (HOTJAR_SITEID.length > 0)" ref="rsspCookieBanner" :debug="false"
      :disable-decline="true" :show-postpone-button="false" element-id="rsspCookieBanner" position="bottom"
      transition-name="slideFromBottom" type="bar" @clicked-accept="cookieClickedAccept"
      @clicked-decline="cookieClickedDecline" @clicked-postpone="cookieClickedPostpone"
      @removed-cookie="cookieRemovedCookie" @status="cookieStatus"
    >
      <!-- Optional -->
      <template #postponeContent>&times;</template>

      <!-- Optional -->
      <template #message>
        {{ $t("cookie.bannerDescription") }}
        <a :href="cookiePolicyURL" target="_blank">{{
          $t("cookie.learnMore")
        }}</a>
      </template>

      <!-- Optional -->
      <template #declineContent>{{ $t("cookie.optOut") }}</template>

      <!-- Optional -->
      <template #acceptContent>{{ $t("cookie.acceptPolicy") }}</template>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import seal from '@/services/api/seal.js'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import { mapGetters } from 'vuex'
import Role from '../Role'
import { showToastError } from '../event-bus'
import server from '../services/api/server'

export default {
  name: 'LayoutContent',
  components: {
    VueCookieAcceptDecline
  },
  props: {
    headerlogo: {
      type: String,
      default: undefined
    }
  },

  data() {
    const rdssPublicUrl = this.$store.state.remoteConfig && this.$store.state.remoteConfig.rdssPublicUrl
    const isRDSSMenusActive = rdssPublicUrl ? rdssPublicUrl.length > 0 : false

    const menuOnlyRSSP = [
      {
        title: this.$t('navigationMenu.dashboard'),
        localeId: 'navigationMenu.dashboard',
        id: 'menu_dashboard',
        icon: 'mdi-view-dashboard-outline',
        link: '/dashboard',
        allowedRoles: [Role.ADMIN, Role.USER]
      },
      {
        title: this.$t('navigationMenu.users'),
        localeId: 'navigationMenu.users',
        id: 'menu_users',
        icon: 'mdi-account-multiple',
        link: '/users',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.myCredentials'),
        localeId: 'navigationMenu.myCredentials',
        id: 'menu_credentials',
        icon: 'mdi-certificate-outline',
        link: '/credentials',
        allowedRoles: [Role.USER]
      },
      {
        title: this.$t('navigationMenu.credentialsAllAdmin'),
        localeId: 'navigationMenu.credentialsAllAdmin',
        id: 'menu_credentials_all_admin',
        icon: 'mdi-certificate-outline',
        link: '/credentialsAdmin',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.devices'),
        localeId: 'navigationMenu.devices',
        id: 'menu_devices',
        icon: 'mdi-cellphone',
        link: '/devices',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.license'),
        localeId: 'navigationMenu.license',
        id: 'menu_license',
        icon: 'mdi-license',
        link: '/license',
        allowedRoles: [Role.ADMIN]
      }
    ]

    const menuWithRDSS = [
      {
        title: this.$t('navigationMenu.dashboard'),
        localeId: 'navigationMenu.dashboard',
        id: 'menu_dashboard',
        icon: 'mdi-view-dashboard',
        link: '/dashboardRDSS',
        allowedRoles: [Role.ADMIN, Role.USER]
      },
      {
        title: this.$t('navigationMenu.documents'),
        localeId: 'navigationMenu.documents',
        id: 'menu_documents',
        icon: 'mdi-file-document',
        href: '/documents',
        allowedRoles: [Role.USER]
      },
      {
        title: this.$t('navigationMenu.allDocuments'),
        localeId: 'navigationMenu.allDocuments',
        id: 'menu_all_documents',
        icon: 'mdi-file-document-multiple',
        href: '/allDocuments',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.recycleBinDocuments'),
        localeId: 'navigationMenu.recycleBinDocuments',
        id: 'menu_recyclebin_documents',
        icon: 'mdi-trash-can',
        href: '/recycleBinDocuments',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.signatureProfiles'),
        localeId: 'navigationMenu.signatureProfiles',
        id: 'menu_signature_profiles',
        icon: 'mdi-draw-pen',
        href: '/signatureProfiles',
        allowedRoles: [Role.USER]
      },
      {
        title: this.$t('navigationMenu.users'),
        localeId: 'navigationMenu.users',
        id: 'menu_users',
        icon: 'mdi-account-multiple',
        link: '/users',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.usersRDSS'),
        localeId: 'navigationMenu.usersRDSS',
        id: 'menu_users_rdss',
        icon: 'mdi-account-multiple',
        link: '/users-rdss',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.myCredentials'),
        localeId: 'navigationMenu.myCredentials',
        id: 'menu_credentials',
        icon: 'mdi-certificate-outline',
        link: '/credentialsRDSS',
        allowedRoles: [Role.USER]
      },
      {
        title: this.$t('navigationMenu.credentialsAllAdmin'),
        localeId: 'navigationMenu.credentialsAllAdmin',
        id: 'menu_credentials_admin',
        icon: 'mdi-certificate-outline',
        link: '/credentialsAdmin',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.importedCredentials'),
        localeId: 'navigationMenu.importedCredentials',
        id: 'menu_import_credentials',
        icon: 'mdi-certificate-outline',
        link: '/importedCredentials',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.importedEvroTrustCredentials'),
        localeId: 'navigationMenu.importedEvroTrustCredentials',
        id: 'menu_imported_evrotrust_credentials',
        icon: 'mdi-certificate-outline',
        link: '/importedEvroTrustCredentials',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.devices'),
        localeId: 'navigationMenu.devices',
        id: 'menu_devices',
        icon: 'mdi-devices',
        link: '/devices',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.signatureBackground'),
        localeId: 'navigationMenu.signatureBackground',
        id: 'menu_signaturebackground',
        icon: 'mdi-draw-pen',
        link: '/signature-background',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.license'),
        localeId: 'navigationMenu.license',
        id: 'menu_license',
        icon: 'mdi-license',
        link: '/license',
        allowedRoles: [Role.ADMIN]
      },
      {
        title: this.$t('navigationMenu.quantumSafeDemo'),
        localeId: 'navigationMenu.quantumSafeDemo',
        id: 'menu_quantumsafe_demo',
        icon: 'mdi-shield-bug-outline',
        link: '/quantum-safe-demo',
        allowedRoles: [Role.USER]
      }
    ]

    const myThemesList = ['i4p', 'Thirdparty Red', 'Thirdparty Dark', 'From server config']
    return {
      rsspVersion: null,
      rdssVersion: null,
      showDevFeatures: false,
      selectedTab: 0,
      drawer: true,
      mobileWarning: false,
      myThemes: myThemesList,
      selectedTheme: myThemesList[0],
      headerLogoUrl: null,
      HOTJAR_SITEID: this.$store.state.remoteConfig.hotjarSiteId,
      cookiePolicyURL: this.$store.state.remoteConfig ? this.$store.state.remoteConfig.cookiePolicyURL : '',
      evroEnabled: this.$store.state.remoteConfig.evroEnabled ? this.$store.state.remoteConfig.evroEnabled : false,
      menus: isRDSSMenusActive ? menuWithRDSS : menuOnlyRSSP,
      menuWithRoles: [],
      sealStatus: {
        enabled: false,
        secureMode: false,
        activated: false
      },
      versionHovered: false,
      hideCredentialsMenu: this.$store.state.remoteConfig && this.$store.state.remoteConfig.sealSign,
      isRDSSMenusActive: isRDSSMenusActive
    }
  },

  computed: {
    ...mapGetters(['hasRole']),
    isAdmin() {
      return this.hasRole(Role.ADMIN)
    },
    isLoggedIn() {
      return !!this.$store.state.currentUser
    },

    currentUser() {
      return this.$store.state.currentUser
    },

    hasMatchedMenuRoles() {
      return this.menuWithRoles
    },

    userProfileLink() {
      if (this.$store.state.remoteConfig && this.$store.state.remoteConfig.rdssPublicUrl && this.$store.state.remoteConfig.rdssPublicUrl.length > 0) {
        return '/user/profilerdss'
      } else {
        return '/user/profile'
      }
    },

    /* hasMatchedMenuRoles() {
      return this.menus.filter(item => {
        // Filter out menu_credentials based on hideCredentialsMenu variable
        if (item.id === 'menu_credentials' && this.hideCredentialsMenu) {
          return false
        }
        return this.hasMatchedRoles(item.allowedRoles, this.$store.state.currentUser.roles)
      })
    }, */
    sealEnabled() {
      return this.sealStatus.enabled
    },
    forceMobileWarningHidden() {
      return !!this.$cookies.get('forceMobileWarningHidden')
    }
  },

  watch: {
    headerlogo(val) {
      this.headerLogoUrl = val
    }
  },

  async mounted() {
    this.sealStatus = await seal.getSealStatus()
    this.updateMenuRoles()

    try {
      const rsspVersion = await server.getVersionInfo()
      this.rsspVersion = rsspVersion.versionStringShort
    } catch (error) {
      showToastError("Can't get RSSP version info" + ' ' + error)
    }

    try {
      if (this.$store.state.remoteConfig.rdssApiUrl && this.$store.state.remoteConfig.rdssApiUrl.length > 0) {
        const rdssVersion = await server.getRDSSVersionInfo()
        this.rdssVersion = rdssVersion.versionStringShort
      }
    } catch (error) {
      showToastError("Can't get RDSS version info" + ' ' + error)
    }

    this.headerLogoUrl = this.headerlogo
    this.checkMobileWarning()

    this.$nextTick(() => {
      window.addEventListener('resize', this.checkMobileWarning)
    })
    this.drawer = true
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobileWarning)
  },

  methods: {
    hasMatchedRoles(itemRoles, currentUserRoles) {
      const matchedRoles = currentUserRoles.filter(role => itemRoles.includes(role))
      return !!matchedRoles.length
    },

    /* updateMenuRoles() {
      // Recalculate the menu roles based on the new locale
      // console.log('Recalculate the menu roles based on the new locale')
      // Update the menus array with retranslated titles
      this.menus.forEach(menu => {
        menu.title = this.$t(menu.localeId)
      })
      this.menuWithRoles = this.menus.filter(item => {
        // Filter out menu_credentials based on sealEnabled
        if (item.id === 'menu_credentials' && this.sealEnabled) {
          return false
        }
        return this.hasMatchedRoles(item.allowedRoles, this.$store.state.currentUser.roles)
      })
    }, */
    updateMenuRoles() {
      // console.log('updateMenuRoles', this.$store.state.currentUser.roles)
      // Recalculate the menu roles based on the new locale
      // console.log('Recalculate the menu roles based on the new locale')
      // Update the menus array with retranslated titles
      this.menus.forEach(menu => {
        menu.title = this.$t(menu.localeId)
      })
      this.menuWithRoles = this.menus.filter(item => {
        // Filter out menu_credentials based on sealEnabled
        if (item.id === 'menu_credentials') {
          if (!this.isAdmin && this.sealEnabled && !this.debugModeForCredentials) {
            return false
          }
          /* if (this.isAdmin) {
            return false
          } */
        } else
        if (item.id === 'menu_imported_evrotrust_credentials') {
          if (this.isAdmin && this.evroEnabled) {
            return true
          } else {
            return false
          }
        }
        // console.log('menuWithRoles', item)
        const val = this.hasMatchedRoles(item.allowedRoles, this.$store.state.currentUser.roles)

        return val
      })
      if (this.isRDSSMenusActive && !this.$store.state.remoteConfig.poorManSignEnabled) {
        this.menuWithRoles.pop()
      }
    },
    changeRoute(route) {
      this.$router.push(route)
    },

    checkMobileWarning() {
      if (!this.forceMobileWarningHidden && window.innerWidth <= 600) {
        this.mobileWarning = true
      } else {
        this.mobileWarning = false
      }
    },

    closeMobileWarning() {
      this.$cookies.set('forceMobileWarningHidden', true)
      this.mobileWarning = false
    },

    setTheme(themename) {
      this.$emit('themeChanged', this.selectedTheme)
    },
    initHotjar() {
      /* const hotjarVersion = 6;
      Hotjar.init(this.hotharSiteId, hotjarVersion); */
    },
    cookieClickedAccept() {
      // console.log("cookieClickedAccept")
    },
    cookieClickedDecline() {
      // console.log("cookieClickedDecline")
    },
    cookieClickedPostpone() {
      // console.log("cookieClickedPostpone")
    },
    cookieStatus(status) {
      // console.log("cookieStatus", status)
      if (status === 'decline') {

      } else {
        this.initHotjar()
      }
    },
    cookieRemovedCookie() {
      // console.log("cookieRemovedCookie")
    },
    versionHoveredHandle() {
      setTimeout(() => {
        this.versionHovered = false
      }, 2000) // 2000 milliseconds = 2 seconds
    }
  }
}
</script>

<style scoped>
.hand {
  cursor: pointer;
}

.textwhite {
  color: white !important;
}

.v-tab--active {
  background-color: #fff4dc !important;
  border-radius: 5px;
  font-weight: 500;
}

.header-button {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.versionBottom {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 0;
  background-color: inherit;
  opacity: 0.65;
  font-size: 15px;
  transition: opacity 0.5s ease;
  /* for smooth transition */
}

.versionBottom.hidden {
  z-index: -1;
  opacity: 0;
}

.hidden {
  display: none !important;
}

.mobilewarning {
  position: fixed;
  top: -40%;
  z-index: 1002;
}
</style>
